module.exports = __webpack_public_path__ + "img/Slice7-min.17f8ea00.png";